// src/components/ui/Card.jsx
import React from "react";

/**
 * Card surface — light theme.
 *
 * Variants:
 *   - "default"  white card with soft shadow (the workhorse)
 *   - "soft"     off-white secondary surface
 *   - "gold"     green-tinted accent card
 *   - "teal"     teal-tinted accent card
 *   - "red"      red-tinted danger card
 *   - "panel"    DARK navy "hero panel" — used for the Landing hero,
 *                 contact CTA, and the featured monthly plan
 */
export default function Card({
  children,
  variant = "default",
  className = "",
  ...rest
}) {
  const styles = {
    default: {
      background: "var(--surf)",
      border: "1px solid var(--border)",
      borderRadius: "var(--r-xl)",
      padding: "22px",
      boxShadow: "var(--shadow-soft)",
    },
    soft: {
      background: "var(--surf-2)",
      border: "1px solid var(--border)",
      borderRadius: "var(--r-lg)",
      padding: "16px",
    },
    gold: {
      background:
        "linear-gradient(135deg, rgba(46,229,107,0.10), rgba(46,229,107,0.04))",
      border: "1px solid var(--gold-border)",
      borderRadius: "var(--r-lg)",
      padding: "16px",
    },
    teal: {
      background: "var(--teal-dim)",
      border: "1px solid var(--teal-border)",
      borderRadius: "var(--r-lg)",
      padding: "16px",
    },
    red: {
      background: "var(--red-dim)",
      border: "1px solid var(--red-border)",
      borderRadius: "var(--r-lg)",
      padding: "16px",
    },
    panel: {
      background: "var(--panel)",
      color: "var(--on-panel)",
      borderRadius: "var(--r-xl)",
      padding: "32px",
      position: "relative",
      overflow: "hidden",
    },
  }[variant];

  return (
    <div className={className} style={styles} {...rest}>
      {children}
    </div>
  );
}
